import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import InsightsOutlinedIcon from "@mui/icons-material/InsightsOutlined";
import NotificationsActiveIcon from "@mui/icons-material/NotificationsActive";
import { Box, FormControlLabel, Switch, Tooltip, Typography } from "@mui/material";

import usePlatform from "@/hooks/usePlatform";
import useThemeData from "@/hooks/useThemeData";

const TrackPriceCardPure = (props: { value: boolean; onChange: (v: boolean) => void }) => {
  const { isPc } = usePlatform();
  const theme = useThemeData();
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    props.onChange(event.target.checked);
  };

  const TrackPricePC = (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        border: '1px solid',
        borderColor: theme.palette.primary.main,
        borderRadius: 2, // 1 = 8px
        px: 2,
      }}
    >
      <FormControlLabel
        className="!mr-[0px]"
        control={
          <Switch
            inputProps={{ "aria-label": "controlled" }}
            checked={props.value}
            onChange={handleChange}
          />
        }
        label={
          <div className="flex items-center">
            <div className="flex items-center mx-[0px] ml-[-1px]">
              <Typography color="primary" fontWeight={600}>
                Advanced Alerts
              </Typography>
              <NotificationsActiveIcon color="primary" className="ml-[3px]" />
              <Tooltip
                sx={{ size: 10 }}
                title={
                  <div>
                    <Typography>
                      Get email and SMS alerts when award availability or prices change for the next trips you want to take — so you never miss a deal.
                    </Typography>
                  </div>
                }
              >
                <InfoOutlinedIcon
                  sx={{
                    fontSize: 16,
                    marginLeft: "4px",
                    color: (theme) => theme.palette.text.secondary,
                  }}
                />
              </Tooltip>
            </div>
          </div>
        }
      />
    </Box>
  );

  return isPc ? TrackPricePC : null;
};

export default TrackPriceCardPure;
